var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditProjCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2478",
    width: 45,
    height: 45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Bearbeiten"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bearbeiten",
    clipPath: "url(#clip-Bearbeiten)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1406",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_522",
    d: "M32.723,12.223a4.534,4.534,0,0,0-6.4,0L13.307,25.234a.969.969,0,0,0-.239.43l-.014,0-2.065,7.053a1,1,0,0,0,1.241,1.241l7.055-2.062,0-.014a1,1,0,0,0,.431-.238L32.723,18.628a4.534,4.534,0,0,0,0-6.405M13.741,30.431l.759-2.59,2.6,2.6-2.591.757ZM19,29.518l-3.577-3.577L25.964,15.4l3.577,3.577Zm11.95-11.95-3.577-3.577.355-.354a2.529,2.529,0,1,1,3.576,3.577Z",
    fill: "inherit"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProjCard);
export default __webpack_public_path__ + "static/media/edit-proj-card.9b5ce8d9.svg";
export { ForwardRef as ReactComponent };